import { createSlice }                  from '@reduxjs/toolkit';
import * as eventParentCategoryReducers from 'Redux/Reducers/EventParentCategory';
import { EventParentCategory }          from 'Domain/Models';

export interface IEventParentCategoryState {
  openRequests: string[],
  failedRequests: string[],
  updatedAt: number,
  entries: Record<string, EventParentCategory>,
  lastUpdateId: string | null,
  maxCount: number,
}

export const eventParentCategorySlice = createSlice({
  name: 'eventParentCategory',
  initialState: {
    openRequests: [],
    failedRequests: [],
    entries: {},
    maxCount: 0,
    lastUpdateId: null,
    updatedAt: 0,
  },
  reducers: eventParentCategoryReducers,
});
